import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    background: ${theme.colors.darkGrey};
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    width: 80vw;
    height: 80vh;
    display: flex;
    flex-direction: column;
    background: ${theme.colors.lightGrey};
    border-radius: 10px;
  `}
`;

export const LeafRightContent = styled.div`
  display: flex;
  justify-content: right;
`;

export const LogoContent = styled.div`
  display: flex;
  justify-content: center;
`;

export const InfoContent = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;
  font-size: 16px;
`;

export const LoadingContent = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

export const LeafLeftContent = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
  bottom: 0;
`;
